import React from 'react';
import PropTypes from 'prop-types';

const Learning_22_05_2025 = () => (
<div>
    <h3>Learning_22_05_2025 Component</h3>
    <p>hello</p>
    <input type='textarea'></input>
    </div>
);

Learning_22_05_2025.propTypes = {};

Learning_22_05_2025.defaultProps = {};

export default Learning_22_05_2025;
